import { ActivityHistoryCard, useModal } from '@europrocurement/flexy-components';
import { addNoteIcon } from '@europrocurement/l2d-icons';
import ActivitiesCardContent from '@europrocurement/l2d-modules/modules/Dossiers/components/detail/ActivitiesCardContent/ActivitiesCardContent';
import useActivitiesHook from '@europrocurement/l2d-modules/modules/Dossiers/hooks/useActivitiesHook';
import { useTheme } from '@mui/material';
import React, { useMemo } from 'react';
import { DossierOpenSearch } from '@europrocurement/l2d-domain';
import {
    CurrentDossierProvider,
    // CurrentDossierProvider,
    useCurrentDossierCtx,
} from '@europrocurement/l2d-modules/modules/Dossiers/providers/CurrentDossierProvider';

type ModalListNotesProps = {
    dossierProps: DossierOpenSearch;
};

const ModalListNotes: React.FunctionComponent<ModalListNotesProps> = function ({ dossierProps }) {
    const { modalActions } = useModal();
    const { dossier } = useCurrentDossierCtx();
    const { activities, activitiesLoading, handleAddNote, handleEditNote, handleDeleteNote } =
        useActivitiesHook({
            // Re-open the modal on success
            actionOnSuccess: () => {
                if (!dossier || !dossier.id) {
                    return;
                }
                modalActions.call(
                    <CurrentDossierProvider
                        autoload
                        idDossier={dossier.id.toString()}
                    >
                        <ModalListNotes dossierProps={dossierProps} />
                    </CurrentDossierProvider>,
                );
            },
            defaultMemoClient: true,
        });

    const { palette } = useTheme();

    const actions = useMemo(
        () => [
            {
                id: 'add-note',
                label: 'Ajouter une note',
                shortLabel: 'Ajouter',
                icon: addNoteIcon,
                onClick: handleAddNote,
                variant: 'text' as const,
                color: palette.grey[700],
            },
        ],
        [handleAddNote, palette.grey],
    );
    return (
        <ActivityHistoryCard actions={actions}>
            <ActivitiesCardContent
                activities={activities.filter((note) => note.memoClient)}
                onEditNote={handleEditNote}
                onDeleteNote={handleDeleteNote}
                activitiesLoading={activitiesLoading}
            />
        </ActivityHistoryCard>
    );
};

export default ModalListNotes;
